import { Box } from '@mui/material';
import MainContainer from 'src/components/common/MainContainer';
import AnalyticsPackageHeader from 'src/features/AnalyticsPackage/Common/Header';
import Information from 'src/features/AnalyticsPackage/Common/Information';
import CompanyDataPackage from 'src/features/AnalyticsPackage/CompanyDataPackage';
import ProductExportPackage from 'src/features/AnalyticsPackage/ProductExportPackage';
import ProductImportPackage from 'src/features/AnalyticsPackage/ProductImportPackage';
import TradeBalanceDataPackage from 'src/features/AnalyticsPackage/TradeBalanceDataPackage';
import { useQueryParams } from 'src/hooks/useQueryParam';
import MainLayout from 'src/layouts';
import { TypeDataPackage } from 'src/utils/constants/enum';

const AnalyticsPackage = () => {
  const { type_package = TypeDataPackage.top_20_export_company_in_country } = useQueryParams();

  const renderTable = () => {
    switch (type_package) {
      case TypeDataPackage.top_20_export_company_in_country:
      case TypeDataPackage.top_20_import_company_in_country:
        return <CompanyDataPackage />;
      case TypeDataPackage.top_20_export_product_in_country:
        return <ProductExportPackage />;
      case TypeDataPackage.top_20_import_product_in_country:
        return <ProductImportPackage />;
      default:
        return <TradeBalanceDataPackage />;
    }
  };

  return (
    <MainLayout>
      <MainContainer>
        <AnalyticsPackageHeader />
        <Box mt={3} />
        <Information />
        <Box mt={3} />
        {renderTable()}
      </MainContainer>
    </MainLayout>
  );
};

export default AnalyticsPackage;
